module.exports = __webpack_public_path__ + "../static/img/vry.2e8bf193.jpg";